import {API_HOST, AXIOS_INSTANCE} from './api'

export async function GET_COORDINATED_CARES() {
	const response = await AXIOS_INSTANCE.get(`${API_HOST}/coordinated-care`, {
		headers: {
		'Authorization': 'Bearer ' + window.localStorage.getItem('token')
		}
	});
	return response.data;
}

export async function GET_CARE_FILES(id) {
	const response = await AXIOS_INSTANCE.get(`${API_HOST}/coordinated-care/${id}`, {
		headers: {
		'Authorization': 'Bearer ' + window.localStorage.getItem('token')
		}
	});
	return response.data;
}


// WEBPACK FOOTER //
// ./src/services/coordinated_care.js